

import React from 'react';
import { ChangePassword } from '../components/ProfileUser/ChangePassword';
import '../css/profile.css';

export const ChangePassPage = () => {
  return <ChangePassword />;
};
